import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import './main-form.css';
import { Tabs, Icon } from 'antd';
import { FaBoxes } from 'react-icons/fa';
import { AiFillSetting } from "react-icons/ai";
import { MdSettingsEthernet } from "react-icons/md";
import { isDevENV } from '../../util/isDevENV';
import AdvanceModeForm from "./AdvanceModeForm";
import Search_Component from "../search_component";
const { TabPane } = Tabs;


/**
 * @component
 * @category Form Page
 * @name Form
 * @description It contains top tabs i.e. FCl or CONTAINERS tab
 * and LCL/AIR or PALLETS/BOXES/CRATES tab
 * <br> <br>
 * **Example**
 * ```js
 *   <Form />
 * ```
 */
class Form extends Component {
  state = {
    nextBtnClick: isDevENV() ? 3 : 0, //make it to 0 in production
  };

  componentDidMount = () => {
    this.props.updateLoadSummaryText();
    // console.log('isFormSubmitSuccess: ', this.props.isFormSubmitSuccess);
    // if form is already used then don't show next-step button at all
    //increase it's count to max. i.e. 3
    if (this.props.isFormSubmitSuccess) {
      this.setState({ nextBtnClick: 3 });
    }
  };

  /**
   * @description there are two next-step button will appear on FCL mode and LCL/AIR (total shipment) mode
   * But there are three next-step button will appear on LCL/AIR (box/pallet) mode.
   * if custom service is NOT shown, then there would be ONE less next-step button than it used to be.
   * It increases next-step button counter upon click on it.
   * <br> <br>
   * **onNextBtnClick() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  onNextBtnClick = () => {
    this.setState(
      (prevState) => ({ nextBtnClick: 1 + prevState.nextBtnClick }),
      () => {
        // console.log('onNextBtnClick: ', this.state.nextBtnClick);
      }
    );
  };

  /**
   * @description It's fired when users change the tabs on Form modal
   * <br> <br>
   * **onTabsChange(activeKey) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | activeKey     | string        | `1` - when LCL tab is active, `2` - when FCL tab is active|

   * Returns: Type: void
   */
  onTabsChange = (activeKey) => {
    console.log(activeKey);
    this.props.updateActiveTabpane(Number(activeKey) === 2);
    this.props.updateLoadSummaryText();
  };

  onModeChange =(activemode)=>{

    console.log(activemode)

  }

  render() {
    const { nextBtnClick } = this.state;
    const { isFclTabActive } = this.props;

    return (
      <div style={{}} className="form-root">

          <Search_Component />


       {/*   <Tabs*/}
       {/*    defaultActiveKey={isFclTabActive ? 'normal_mode' : 'advance_mode'}*/}
       {/*    onChange={ this.onModeChange }*/}
       {/*>*/}
       {/*  <TabPane*/}
       {/*      tab=*/}
       {/*          {*/}
       {/*        <span className="my-tab-header">*/}
       {/*         <MdSettingsEthernet*/}
       {/*             size={25}*/}
       {/*             style={{ marginRight: '10px', marginBottom: '-5px' }}*/}
       {/*         />*/}
       {/*         Quick quote*/}
       {/*       </span>*/}
       {/*      }*/}
       {/*      key="normal_mode"*/}
       {/*  >*/}
       {/*  </TabPane>*/}

       {/*  <TabPane*/}
       {/*      tab={*/}
       {/*        <span className="my-tab-header">*/}
       {/*         <AiFillSetting*/}
       {/*             size={25}*/}
       {/*             style={{ marginRight: '10px', marginBottom: '-5px' }}*/}
       {/*         />*/}
       {/*         Advanced Quote*/}
       {/*       </span>*/}
       {/*      }*/}
       {/*      key="advance_mode"*/}
       {/*  >*/}
       {/*    <AdvanceModeForm/>*/}
       {/*  </TabPane>*/}
       {/*</Tabs>*/}
      </div>
    );
  }
}

Form.propTypes = {
  /**
   * whether FCL/Containers tab is selected
   */
  isFclTabActive: PropTypes.bool,
  /**
   * Whether Form is successfully submitted for first time.
   */
  isFormSubmitSuccess: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    isFclTabActive: state.form.isFclTabActive,
    isFormSubmitSuccess: state.form.isFormSubmitSuccess,
  };
};

export default connect(mapStateToProps, actions)(Form);
